import React, { Component } from 'react'
import { Button, Popup, Icon, List, Divider, Image, Header } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import "./Toolbar.css";
import ContentImage from '../../../../images/svg/Export/content.svg'
import excelImage from '../../../../images/svg/Export/excel.svg';
import publish_all from '../../../../images/svg/publish_all.svg';
import moment from 'moment';
import _ from 'lodash';
import PublishedAllContentModal from '../../Modal/PublishAllContentModal'
import LoadingComponent from '../../../common/LoadingComponent';
import ContentInfoModal from '../../Modal/ContentInfoModal';
import ConfirmImportModal from '../../Modal/ContentConfirmImportCateforiesModal';

class ToolbarContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            publishAllOpen: false,
            dataType: '',
            contentInfoModal: false,
            contentConfirmImport: false,
            processing:false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isContentImported) {
            dispatch.content.setIsContentImported(false);
            let payload = {};
            payload.organizationId = this.props.selectedOrganisation.id;
            payload.userid = this.props.user._id;
            dispatch.content.getAllContents(payload);
        }
    }

    createContent = async (e) => {
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        await dispatch.content.openResourcePane(null);
        dispatch.content.showLandingPage(false);
        const { history } = this.props;

        dispatch.content.setEditContentPage(false);
        dispatch.content.authorizeBreadcrum(false);
        dispatch.content.showAddContentBreadCrum(true);
        dispatch.content.clearContent();

        history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_ct/add`);
    }

    stopLoader = () => {
        this.setState({ processing: false });
        let payload = {};
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.userid = this.props.user._id;
        dispatch.content.getAllContents(payload);
    }

    downloadExportedContent = async (payload) => {
        await dispatch.content.getMyContenetsToExport(payload);
        var dataStr =
            "data:text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(this.props.contentsToExport));

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataStr);
        } else {
            //for firfox/chrome
            let link = document.createElement("a");
            link.href = dataStr;
            link.download = this.props.selectedOrganisation.name + ".content";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    downloadExportedContentAsExcel = async (payload) => {
        try {
            await dispatch.content.getContentListData(payload);
            // this.setState({ downloadCSVFileFlag: false });
            while (!this.props.contentListDataforCSV || this.props.contentListDataforCSV.length === 0) {
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            this.createCsvFile(this.props.contentListDataforCSV);
    
            payload.query.$limit = this.state.oldLimit;
            dispatch.app.setTableFilterQuery(payload.query);
        } catch (error) {
            toastr.error("Message", "Something went Wrong.");
        }
    }

    async fileUploaded(data) {
        if (data.target.files[0].name.split('.').pop() === 'contents' || data.target.files[0].name.split('.').pop() === 'content') {
            this.setState({ processing: true })
            var fileToLoad = data.target.files[0];
            let selectedOrganisation = this.props.selectedOrganisation;
            let selectedAccount = this.props.selectedAccount;

            var fileReader = new FileReader();
            fileReader.onload = async (fileLoadedEvent) => {
                if (fileLoadedEvent.target.result) {
                    await dispatch.content.decodeContents({ data: fileLoadedEvent.target.result, organizationId: selectedOrganisation.id, accountId: selectedAccount._id });
                    this.setState({ fileData: fileLoadedEvent.target.result })
                    this.setState({ contentConfirmImport: true })
                    this.setState({ processing: false });
                } else {
                    toastr.error('Message', 'Invalid Content File.');
                    this.stopLoader();
                }
            };

            fileReader.readAsText(fileToLoad, "UTF-8");
            data.target.value = null;
        } else {
            toastr.error('Message', 'Invalid Content File.');
        }
    }
    assignCategoriesModal = async () => {
        this.setState({ contentInfoModal: true })
        this.closeConfirmModal();
    }
    checkFilterContentBeforeExport = async () => {
        let currentUser =
            this.props.selectedOrganisation &&
            this.props.selectedOrganisation.users &&
            this.props.selectedOrganisation.users.filter(
                (user) => user.accountUserId === this.props.user._id
            );
        let payload = {
            query: this.props.tableFilterQuery,
            params: this.props.routeParams,
            organizationId: this.props.selectedOrganisation.id,
            currentUser: currentUser[0],
        };

        if (this.props.routeParams.status === "publicKnowledgeBank") {
            payload.query.scope = "Public"
        }
        else if (this.props.routeParams.status === "knowledgeBank") {
            payload.query.scope = "Private"
        }
        else {
            delete payload.query.scope;
        }

        if (currentUser[0].role === "Manager" || currentUser[0].role === "Member") {
            let message = (
                <div className="confirmMessage">
                    <h3>Export Content</h3>
                    <p>This will only export the content created by you.</p>
                </div>
            );
            toastr.confirm(message, {
                okText: "Export",
                onOk: async () => {
                    this.downloadExportedContent(payload)
                },
            });
        } else {
            this.downloadExportedContent(payload)
        }

    }

    exportAllContents = async () => {
        let message = <div className="confirmMessage">
            <h3>Export Content</h3>
            <p>This action will export the data you are seeing in
                the Content table. If you would like to export all content,
                you need to reset the filter and perform export again.</p>
        </div>

        if (this.props.tableFilterQuery && this.props.tableFilterQuery.$and) {
            toastr.confirm(message, {
                okText: 'Export',
                onOk: async () => {
                    this.checkFilterContentBeforeExport()
                }
            });
        } else {
            this.checkFilterContentBeforeExport()
        }
    }

    exportAsCSV = async () => {
        let currentUser =
            this.props.selectedOrganisation &&
            this.props.selectedOrganisation.users &&
            this.props.selectedOrganisation.users.filter(
                (user) => user.accountUserId === this.props.user._id
            );
        let payload = {
            query: this.props.tableFilterQuery,
            params: this.props.routeParams,
            currentUser: currentUser[0],
        };


        this.setState({ oldLimit: payload.query.$limit })
        payload.query.$limit = 1000;

        if (this.props.routeParams.status === "publicKnowledgeBank") {
            payload.query.scope = "Public"
        }
        else if (this.props.routeParams.status === "knowledgeBank") {
            payload.query.scope = "Private"
        }
        else {
            delete payload.query.scope;
        }

        if (currentUser[0].role === "Manager" || currentUser[0].role === "Member") {
            let message = (
                <div className="confirmMessage">
                    <h3>Export Content</h3>
                    <p>This will only export the content created by you.</p>
                </div>
            );

            toastr.confirm(message, {
                okText: "Export",
                onOk: async () => {
                    this.downloadExportedContentAsExcel(payload);
                },
            });
        } else {
            this.downloadExportedContentAsExcel(payload);

        }

    }

    // Creating the excel structure and download function to download excel
    createCsvFile = (data) => {
        let csv = '';
        let items = data
        // Loop the array of objects
        for (let row = 0; row < items.length; row++) {

            let keysAmount = Object.keys(items[row]).length
            let keysCounter = 0
            // If this is the first row, generate the headings
            if (row === 0) {
                // Loop each property of the object
                for (let key in items[row]) {
                    // This is to not add a comma at the last cell
                    // The '\n' adds a new line
                    csv += key + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                    keysCounter++
                }
                keysCounter = 0;
                for (let key in items[row]) {
                    csv += `"${items[row][key]}"` + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                    keysCounter++
                }
            } else {
                for (let key in items[row]) {
                    csv += `"${items[row][key]}"` + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
                    keysCounter++
                }
            }
            keysCounter = 0
        }
        // Once we are done looping, download the .csv by creating a link
        let csvFileName = this.props.selectedOrganisation.name ? this.props.selectedOrganisation.name : moment().unix()
        let link = document.createElement('a')
        link.id = 'download-csv'
        link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
        link.setAttribute('download', csvFileName + '.csv');
        document.body.appendChild(link)
        document.querySelector('#download-csv').click()
        setTimeout(() => {
            var el = document.getElementById('download-csv');
            el.remove();
        }, 100);
    }

    copyContent = async (e, content) => {
        await dispatch.content.copyContent(content);

        let payload = {
            query: this.props.tableFilterQuery,
            params: this.props.routeParams
        };
        await dispatch.content.getContentListData(payload)
    }


    componentWillMount() {
        dispatch.lifeCycle.activePage(null);
    }

    handlePublishAllModal = async (e, open, type) => {
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        // this.setState({ loading: true })
        await dispatch.content.openResourcePane(null);
        let payload = {
            query: {...this.props.baseTableQuery},
            params: { ...this.props.routeParams, status: this.props.routeParams.status }
        };
        let access = ""
        if (open) {
            // this.setState({ message: "Fetching data..." })
            payload.params.dataType = type;
            payload.query.$limit = 100;
            access = "Private"
        } else {
            // this.setState({ message: "Processing..." })
          //  payload.query.$limit =this.props.baseTableQuery && this.props.baseTableQuery.$limit ? this.props.baseTableQuery.$limit : this.props.tableFilterQuery.$limit;
            access = this.props.routeParams && this.props.routeParams.status === "knowledgeBank" ? "Private" :
                this.props.routeParams.status === "publicKnowledgeBank" ? "Public"
                    : "all"
        }

        if (payload.query.$and) {
            if(!this.props.baseTableQuery) delete payload.query.$and
        }
      //  await dispatch.categories.getCategoryTreeByAccess({ "accountId": this.props.selectedAccount._id, access: access });
        await dispatch.content.getContentListData(payload)
        // await dispatch.content.bulkOperationIds(payload)

        this.setState({ publishAllOpen: open, dataType: type, loading: true })

        setTimeout(() => {
            this.setState({ loading: false });
        }, 2100);
    }
    closeConfirmModal = () => {
        this.setState({ contentConfirmImport: false })
    }
    closeInfoModal = () => {
        this.setState({ contentInfoModal: false })
    }
    submitInfoModal = async (data) => {
        let payload;
        if(data){
             payload = {
                categories: data,
                data: this.state.fileData,
                organizationId: this.props.selectedOrganisation.id,
                accountId: this.props.selectedAccount._id
            }
        } else {
            payload = {
                data: this.state.fileData,
                organizationId: this.props.selectedOrganisation.id,
                accountId: this.props.selectedAccount._id
            }
        }
        this.closeConfirmModal();
        this.closeInfoModal();
        await dispatch.content.importContents(payload);
    }

    render() {
        let checkDataAvailable = _.isEmpty(this.props.selectedContent) || !this.props.resourcePaneFlag
        let isAuthorizedToCopy = false

        if (this.props.user._id && this.props.selectedContent.author && this.props.user._id.toString() === this.props.selectedContent.author.toString()) {

            if (this.props.selectedContent && this.props.selectedContent.organizationId && this.props.selectedOrganisation.id.toString() === this.props.selectedContent.organizationId.toString()) {
                isAuthorizedToCopy = true;
            }
        }
        let isExecutive = false;
        if (this.props.selectedContent && this.props.selectedContent.organizationId && this.props.selectedOrganisation.id.toString() === this.props.selectedContent.organizationId.toString()) {
            this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.map(user => {
                if ((user && user.id && user.id.toString() === this.props.user && this.props.user._id.toString()) && user.role === "customerAdmin") {
                    isExecutive = true;
                }
            });
            if (!isExecutive) {
                if (this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'workspaceOwner') {
                    isExecutive = true;
                }
            }
        }

        let isCopyAccess = checkDataAvailable || (!isAuthorizedToCopy && !isExecutive)


        return (
            <div className="toolBar header_buttons" >
                <LoadingComponent active={this.state.loading} message={this.state.message} />
                <LoadingComponent active={this.state.processing} message={"Loading..."} />
                <Button.Group size='mini' className="mar_Right_5">
                    <Popup className="popupStyled" inverted trigger={<span><Button icon='plus' className="clr-blue" onClick={this.createContent} onMouseEnter={() => dispatch.app.setHelpContext("Add Content")} /></span>}
                        content='Create Content'
                    />
                    <Popup className="popupStyled" inverted trigger={
                        <label className={this.props.activePageTab == 'createContent' ? "disabledImportIcon" : "exportIcon"} onMouseEnter={() => dispatch.app.setHelpContext("Import Content")}>
                            <Icon name='cloud upload' className="clr-blue f_16" style={{ verticalAlign: "top", margin: "-2px 0 0 0" }} />
                            <input type="file" name="file" id="file" className="inputfile" onChange={(e) => this.fileUploaded(e)} accept=".contents,.content" disabled={this.props.activePageTab == 'createContent'} />
                        </label>}
                        content='Import Content'
                    />
                    <Popup
                        trigger={<span><Button disabled={this.props.contentCountData && this.props.contentCountData.total === 0} >
                            <Image src={publish_all} />
                        </Button></span>}
                        flowing
                        on="hover"
                        hoverable
                        disabled={this.props.contentCountData && this.props.contentCountData.total === 0}
                        style={{ zIndex: "99" }}
                    >
                        <Header className="f_14 mar_0"> Bulk Operation </Header>
                        <Divider style={{ margin: "5px 0" }} />
                        <List selection verticalAlign='middle'>

                            <List.Item disabled={this.props.contentCountData && this.props.contentCountData.inDevelopment === 0} onClick={(e) => this.handlePublishAllModal(e, true, "publishAll")}>
                                <Icon name="check circle" className="clr-blue" />
                                <List.Content>Publish</List.Content>
                            </List.Item>

                            <List.Item onClick={(e) => this.handlePublishAllModal(e, true, "updateCategory")}>
                                <Icon name="tasks" className="clr-green" />
                                <List.Content>Change Category </List.Content>
                            </List.Item>
                            <List.Item onClick={(e) => this.handlePublishAllModal(e, true, "deleteAll")}>
                                <Icon name="trash alternate" className="trash-color" />
                                <List.Content>Delete Contents </List.Content>
                            </List.Item>
                        </List>
                    </Popup>
                </Button.Group>

                <Button.Group size='mini' className="mar_Right_5">
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={
                            <span>
                                <Button
                                    icon='copy'
                                    className="clr-green"
                                    onClick={(e) => this.copyContent(e, this.props.selectedContent)}
                                    disabled={isCopyAccess}
                                />
                            </span>}
                        content='Copy Content'
                    />
                    <Popup
                        trigger={<span
                            onMouseEnter={() => dispatch.app.setHelpContext("Export Content")}>
                            <Button
                                icon={<Icon name='cloud download' className="f_16" />}
                                className="clr-green "
                                disabled={(this.props.contentListData && this.props.contentListData.total === 0) || this.props.routeParams.status === "publicKnowledgeBank" ? true : false}
                            />
                        </span>}
                        flowing
                        hoverable
                        disabled={(this.props.contentListData && this.props.contentListData.total === 0) || this.props.routeParams.status === "publicKnowledgeBank" ? true : false}
                        on="hover"
                    >
                        <Header className="f_14 mar_0"> Export as </Header>
                        <Divider style={{ margin: "5px 0" }} />
                        <List selection verticalAlign='middle'>
                            <List.Item onClick={this.exportAllContents}>
                                <Image style={{ height: "16px" }} src={ContentImage} />
                                <List.Content>Content</List.Content>
                            </List.Item>
                            <List.Item onClick={this.exportAsCSV}>
                                <Image style={{ height: "16px" }} src={excelImage} />
                                <List.Content>Excel</List.Content>
                            </List.Item>
                        </List>
                    </Popup>
                </Button.Group>
                {this.state.publishAllOpen ?
                    <PublishedAllContentModal
                        publishAllOpen={this.state.publishAllOpen}
                        dataType={this.state.dataType}
                        handlePublishAllModal={this.handlePublishAllModal}
                        contentListData={this.props.contentListData}
                        selectedOrganisation={this.props.selectedOrganisation}
                        user={this.props.user}
                        routeParams={this.props.routeParams}
                        selectedMultipleIds={this.props.selectedMultipleIds}
                        contentListDataforCSV={this.props.contentListDataforCSV}
                        loadingBulkPublish={this.props.loadingBulkPublish}
                        loadingBulkDelete={this.props.loadingBulkDelete}
                        tableFilterQuery={this.props.tableFilterQuery}
                        categoryList={this.props.categoryList}
                        selectedAccount={this.props.selectedAccount}
                        loadingGetContentListData={this.props.loadingGetContentListData} />
                    : null}
                {this.state.contentConfirmImport &&
                    <ConfirmImportModal
                        contentConfirmImport={this.state.contentConfirmImport}
                        content={this.props.decodedContents}
                        closeConfirmModal={this.closeConfirmModal}
                        submitModal={this.submitInfoModal}
                        assignCategoriesModal={this.assignCategoriesModal}
                    />

                }
                {this.state.contentInfoModal &&
                    <ContentInfoModal
                        contentInfoModal={this.state.contentInfoModal}
                        content={this.props.decodedContents}
                        closeInfoModal={this.closeInfoModal}
                        submitModal={this.submitInfoModal}
                        categoryList={this.props.allCategoryList}
                        selectedAccount={this.props.selectedAccount}

                    />

                }
            </div>
        )
    }
}

export default ToolbarContent

